import { render } from "./GroupManagement.vue?vue&type=template&id=cc0fbe52&scoped=true"
import script from "./GroupManagement.vue?vue&type=script&lang=js"
export * from "./GroupManagement.vue?vue&type=script&lang=js"

import "./GroupManagement.vue?vue&type=style&index=0&id=cc0fbe52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0fbe52"]])

export default __exports__